import React, { useState } from "react";
import "./OfflineMessage.css";

interface Props {
  props: any;
}
const OfflineMessage: React.FC<Props> = ({ props }) => {
  return (
    !props.isOnline && (
      <div className="offline-container">
        <div className="offline-message">
          <img
            className="icon"
            alt="Offline"
            src={require("../../assets/images/offline.png")}
          />
          <h2>You’re offline</h2>
          <p>Please connect to the internet and try again.</p>
          <button onClick={props.handleRetry} className="retry-button">
            Retry
          </button>
        </div>
      </div>
    )
  );
};

export default OfflineMessage;
